import React from 'react';
import { Flame, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencyBanner() {
  const goToOffers = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={goToOffers} aria-label="Ver las ofertas con precio de lanzamiento" className="group block w-full bg-gradient-to-r from-[#EF6C00] via-[#FB8C00] to-[#EF6C00] text-white text-left active:scale-[0.99] transition-transform" data-id="element-355">
      <div className="max-w-3xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3" data-id="element-356">
        <motion.span animate={{
        scale: [1, 1.2, 1],
        rotate: [0, -8, 8, 0]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="shrink-0" data-id="element-357">
          <Flame className="w-5 h-5 fill-white/30" data-id="element-358" />
        </motion.span>
        <p className="text-[13px] sm:text-sm font-bold leading-tight text-center" data-id="element-359">
          <span className="text-yellow-200" data-id="element-360">
            El precio actual es exclusivo para los primeros 200 compradores.
          </span>{' '}
          <span className="underline decoration-yellow-200 underline-offset-2" data-id="element-361">
            ¡Después aumenta!
          </span>
        </p>
        <span className="hidden sm:inline-flex shrink-0 items-center gap-1 bg-white/20 border border-white/30 rounded-full px-3 py-1 text-xs font-bold group-hover:bg-white/30 transition-colors" data-id="element-362">
          Ver ofertas
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" data-id="element-363" />
        </span>
      </div>
    </button>;
}